// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"rL-z","carouselContainer":"sL-z"};